export interface IntegrationLogo {
  label: string;
  parts: Array<{
    src: string;
    width: number;
    height: number;
    mask?: boolean;
  }>;
  text?: string;
}

export const integrationLogos: IntegrationLogo[] = [
  {
    label: 'Cinema 4D',
    parts: [
      { src: '/images/product-integrations/cinema4d-icon.svg', width: 40, height: 46 },
      { src: '/images/product-integrations/cinema4d-wordmark.svg', width: 132, height: 46 },
    ],
  },
  { label: 'Godot', parts: [{ src: '/images/product-integrations/godot.svg', width: 140.399, height: 80 }] },
  { label: 'ComfyUI', parts: [{ src: '/images/product-integrations/comfyui.svg', width: 160, height: 46 }] },
  { label: 'Scenario', parts: [{ src: '/images/product-integrations/scenario.svg', width: 226, height: 58 }] },
  {
    label: 'Autodesk Maya',
    parts: [{ src: '/images/product-integrations/autodesk-maya.svg', width: 176.678, height: 80 }],
  },
  { label: 'Unity', parts: [{ src: '/images/product-integrations/unity.svg', width: 136.605, height: 80 }] },
  {
    label: 'Unreal Engine',
    parts: [{ src: '/images/product-integrations/unreal-engine.svg', width: 296, height: 80 }],
  },
  { label: 'Blender', parts: [{ src: '/images/product-integrations/blender.svg', width: 174.203, height: 80 }] },
  // AI marks/wordmark from @lobehub/icons-static-svg 1.95.1; mask them to match the grayscale ribbon.
  {
    label: 'ChatGPT',
    parts: [{ src: '/images/product-integrations/chatgpt.svg', width: 40, height: 40, mask: true }],
    text: 'ChatGPT',
  },
  {
    label: 'Claude',
    parts: [
      { src: '/images/product-integrations/claude-icon.svg', width: 40, height: 40, mask: true },
      { src: '/images/product-integrations/claude-wordmark.svg', width: 162, height: 40, mask: true },
    ],
  },
];
